// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"906760de","785":"08162fd6","787":"0563e845"}[chunkId] + ".chunk.js";
};